import { createTransactionFromTemplate, getRsTransactions } from '../../../services/pos/transactions';
import { addErrorMessage } from '../message';
import { resolveTransactionErrorCode } from '../../../utils/helpers';

export const RS_TRANSACTIONS_FETCH = 'RS_TRANSACTIONS_FETCH';
export const RS_TRANSACTIONS_SUCCESS = 'RS_TRANSACTIONS_SUCCESS';
export const RS_TRANSACTIONS_ERROR = 'RS_TRANSACTIONS_ERROR';

export const RS_TRANSACTION_CREATE_FETCH = 'RS_TRANSACTION_CREATE_FETCH';
export const RS_TRANSACTION_CREATE_SUCCESS = 'RS_TRANSACTION_CREATE_SUCCESS';

export const getAllRsTransactions = () => async (dispatch) => {
  dispatch({ type: RS_TRANSACTIONS_FETCH });
  try {
    const payload = await getRsTransactions();
    dispatch({ type: RS_TRANSACTIONS_SUCCESS, payload });
  } catch (error) {
    const errorResponse = error.response;

    let errorCode;
    switch (errorResponse?.data?.error) {
      case 'INVALID_CREDENTIALS':
        errorCode = errorResponse?.data?.error;
        break;
      default:
        errorCode = 'UNKNOWN_ERROR';
    }

    dispatch({ type: RS_TRANSACTIONS_ERROR, error: errorCode });
  }
};

export const transformTemplate = (id) => async (dispatch) => {
  dispatch({ type: RS_TRANSACTION_CREATE_FETCH, id });
  try{
    const transactionID = await createTransactionFromTemplate(id);
    dispatch({ type: RS_TRANSACTION_CREATE_SUCCESS, id, transactionID });
  } catch(e){
    const errorResponse = e.response;
    dispatch(addErrorMessage(resolveTransactionErrorCode(errorResponse.data.error)));
  }
};

